<template>
  <div :class="{ open: open }">
    <dl
      :class="panelClass"
      class="panel py-6 px-2 sm:px-0"
    >
      <dt
        class="text-lg"
        :class="termClass"
      >
        <button
          type="button"
          :aria-controls="id"
          :aria-expanded="open.toString()"
          :aria-label="open ? $t('app.close') : $t('app.open')"
          :class="[titleClass, { 'cursor-default': alwaysOpen }]"
          class="text-left w-full flex justify-between items-center focus:outline-none text-neutral-400 hover:opacity-75 transition"
          @click="toggle"
        >
          <span
            class="font-light transition-[font-weight] duration-200 ease-in-out"
            :class="[
              titleClass, {
                'font-semibold text-black': open,
                'text-neutral-600': !isRefresh,
                'text-neutral-950': isRefresh,
                '!font-bold text-white': isDarkBackground,
                'font-semibold text-base leading-5': open && isRefresh,
                'font-normal text-base leading-5': !open && isRefresh,
              }]"
          >
            <slot name="title" />
          </span>
          <span
            v-if="!hideToggleIcon"
            :class="{ 'rotate-180': open }"
            class="ml-6 h-7 flex items-center transition-transform duration-200 ease-in-out"
          >
            <fa
              :icon="['fal', icon]"
              :class="angleIconColor"
              class="text-lg"
            />
          </span>
        </button>
      </dt>
      <transition
        name="accordion"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
      >
        <dd
          v-show="open"
          :id="id"
          :class="contentPadding"
          class="transition-all duration-200 ease-in-out overflow-hidden"
        >
          <div
            :class="{
              'text-base text-neutral-500': !isRefresh,
              'font-normal text-base leading-5 text-neutral-700': isRefresh,
            }"
          >
            <slot name="content" />
          </div>
        </dd>
      </transition>
    </dl>
  </div>
</template>

<script>
import { uuid } from '@/helpers/uuid';

export default {
  name: 'VetsterAccordion',

  props: {
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    contentPadding: {
      type: String,
      default: 'pr-4',
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    hideToggleIcon: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'chevron-down',
    },
    isDarkBackground: {
      type: Boolean,
      default: false,
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
    panelClass: {
      type: String,
      default: '',
    },
    termClass: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      id: `accordion-${uuid()}`,
      open: this.defaultOpen,
    };
  },

  computed: {
    angleIconColor() {
      return this.isDarkBackground ? 'text-white' : 'text-neutral-950';
    },
  },

  methods: {
    enter(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = 'auto';
      const { height } = getComputedStyle(el);
      // eslint-disable-next-line no-param-reassign
      el.style.height = 0;
      getComputedStyle(el);
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        el.style.height = height;
      });
    },
    afterEnter(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = 'auto';
    },
    leave(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = getComputedStyle(el).height;
      getComputedStyle(el);
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        el.style.height = 0;
      });
    },
    toggle() {
      if (!this.alwaysOpen) {
        this.open = !this.open;
      }
    },
  },
};
</script>
